"use client";

import React, { useEffect, useState } from "react";
import dynamic from "next/dynamic";
import { FaPhone, FaWhatsapp } from "react-icons/fa6";
import { MdOutlineEmail } from "react-icons/md";
import { BsHeadset } from "react-icons/bs";
import { useTheme } from "@/app/theme-provider";
import { get } from "@/app/helpers";
import Link from "next/link";

const BannerVideoCarousel = dynamic(
  () => import("@/Components/BannerVideoCarousel"),
  {
    ssr: false,
    loading: () => null,
  }
);

const BannerNewsTicker = dynamic(
  () => import("@/Components/BannerNewsTicker"),
  {
    ssr: false,
    loading: () => null,
  }
);

const DEFAULT_CONTENT = {};

export default function Banner({
  initialLatestNews = [],
  initialVideos = [],
  initialContent = DEFAULT_CONTENT,
  initialLanguage = "ml",
}) {
  const { language } = useTheme();
  const [latestNews, setLatestNews] = useState(initialLatestNews);
  const [videos, setVideos] = useState(initialVideos);
  const [content, setContent] = useState(initialContent);

  useEffect(() => {
    let isMounted = true;

    // if (language === initialLanguage) {
    //   return undefined;
    // }

    Promise.all([
      get("/website/homepage-latest-news"),
      get("website/homepage-banners"),
    ])
      .then(([newsRes, bannerRes]) => {
        if (!isMounted) {
          return;
        }

        setLatestNews(newsRes?.data ?? []);
        setVideos(bannerRes?.data ?? []);
        setContent(bannerRes?.details ?? DEFAULT_CONTENT);
      })
      .catch(() => {});

    return () => {
      isMounted = false;
    };
  }, [initialLanguage, language]);

  return (
    <>
      <section className="position-relative bg-0000">
        <div className="cmpad position-relative">
          <div className="contact-icons">
            <div className="contact-item">
              <a aria-label="phone-link" href="tel:1064" className="contact-icon icon-phone">
                <FaPhone />
              </a>
              <span className="contact-label">1064</span>
            </div>
            <div className="contact-item">
              <a
                aria-label="emaik-link"
                href="mailto:vig.vacb@kerala.gov.in"
                className="contact-icon icon-email"
              >
                <MdOutlineEmail />
              </a>
              <span className="contact-label">vig.vacb@kerala.gov.in</span>
            </div>
            <div className="contact-item">
              <a
                aria-label="whatssapp-link"
                href="https://wa.me/9447789100"
                target="_blank"
                rel="noopener noreferrer"
                className="contact-icon icon-whatsapp"
              >
                <FaWhatsapp />
              </a>
              <span className="contact-label">9447789100</span>
            </div>
            <div className="contact-item">
              <a aria-label="support-link" href="#" className="contact-icon icon-support">
                <BsHeadset />
              </a>
              <span className="contact-label">Working Time : 10.15 AM - 5:15 PM</span>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-4 col-md-12 col-12 order-lg-1 w-500wd order-2">
              <div className="banner-content-box text-white">
                <h1>{content?.banner_title}</h1>
                <p>{content?.banner_description}</p>

                <div className="banner-box-case">
                  <div className="row row-cols-3 gx-0">
                    <div className="col">
                      <div className="h-100 d-flex flex-column align-items-center text-center gap-2 s-border-r">
                        <Link aria-label="fir-online" href="/fir-online">
                          <img
                            src="/icons/e-fir.svg"
                            alt="icon"
                            loading="eager"
                            decoding="async"
                          />
                        </Link>
                        <Link aria-label="fir" href="/fir-online">
                          <p>E-FIR</p>
                        </Link>
                      </div>
                    </div>

                    <div className="col">
                      <div className="h-100 d-flex flex-column align-items-center text-center gap-2 s-border-r">
                        <Link aria-label="ebullet" href="/e-bulletin">
                          <img
                            src="/icons/b-icon1.svg"
                            alt="icon"
                            loading="eager"
                            decoding="async"
                          />
                        </Link>
                        <Link aria-label="ebullet" href="/e-bulletin">
                          <p>E-Bulletin</p>
                        </Link>
                      </div>
                    </div>

                    <div className="col">
                      <div className="h-100 d-flex flex-column align-items-center text-center gap-2">
                        <Link aria-label="complaint-status" href="/complaint-status">
                          <img
                            src="/icons/case-status.svg"
                            alt="icon"
                            loading="eager"
                            decoding="async"
                          />
                        </Link>
                        <Link aria-label="complaint-status" href="/complaint-status">
                          <p>Complaint Status</p>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {videos.length > 0 ? (
          <div className="video-sec">
            <div className="banner-video-sec position-relative">
              <BannerVideoCarousel videos={videos} />
            </div>
          </div>
        ) : null}

        <div className="toll-free">
          <p>{language === "en" ? "Vigilance Toll free" : "ടോൾ ഫ്രീ"}</p>
          <a href="tel:1064">1064</a>
        </div>
      </section>

      <div className="letest-news-box">
        <div className="ribbon-shape">
          <div className="ribbon-round d-flex justify-content-center align-items-center">
            <div className="ribbon-round1"></div>
          </div>
          <p>{language === "en" ? "Latest News" : "പുതിയ വാർത്ത"}</p>
        </div>

        <BannerNewsTicker latestNews={latestNews} />
      </div>
    </>
  );
}
